import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentLocked = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentLocked' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M4,15 L14,15 L14,23 L4,23 L4,15 Z M6,15 L6,13 C6,11.3431458 7.34314575,10 9,10 C10.6568542,10 12,11.3431458 12,13 L12,15 M8,19 L10,19' />
  </StyledIcon>
);
